import React, { useState, useEffect } from 'react';

function UploadPage() {

  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [analysis, setAnalysis] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [showIntro, setShowIntro] = useState(false); // Track intro visibility

  //const APIUrl = 'http://localhost:5000/analyze';
  const APIKey = 'AIzaSyBYyvN_9AnSaKO7AelYDepzLMA2DyoB9mo';
  const APIUrl = 'https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash:generateContent?key=' + APIKey;
  //  https://generativelanguage.googleapis.com/v1beta/models/gemini-pro-vision:generateContent?key=' + apiKey
  const prompt = 'Analyze this image and describe what you see as the main object in basic detail. And also provide a general price estimate for the object for reselling.';
  const AddToResponse = '<br><br><p class="xtra">We will call you withing 5 minutes to take all your moneyyyyyyyyy</p>';

  // Check if intro should be shown
  useEffect(() => {
    const introDismissed = localStorage.getItem('introDismissed');
    if (!introDismissed) {
      setShowIntro(true);
    }
  }, []);

  const handleDismissIntro = () => {
    setShowIntro(false);
    localStorage.setItem('introDismissed', 'true');
  };

  const handleShowIntro = () => {
    setShowIntro(true);
    localStorage.removeItem('introDismissed');
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
      setAnalysis('');
      setError('');
    }
  };
  
  const analyzeImage = async () => {
    if (!selectedImage) {
      setError('Please select an image first');
      return;
    }
  
    setIsLoading(true);
    setError('');
    
    try {
      // Convert image to base64 for API request
      const base64Image = imagePreview.split(',')[1];
  
      // Direct request to Gemini API
      const response = await fetch(APIUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          contents: [
            {
              parts: [
                { text: prompt },
                {
                  inline_data: {
                    mime_type: selectedImage.type,
                    data: base64Image
                  }
                }
              ]
            }
          ],
          generation_config: {
            temperature: 0.4,
            topK: 32,
            topP: 1,
            maxOutputTokens: 4096,
          }
        }),
      });
      
      // Check for errors in the response
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error?.message || `Error: ${response.statusText}`);
      }
      
      const data = await response.json();
  
      // Extract the text from the Gemini response
      if (data.candidates && data.candidates[0]?.content?.parts) {
        //console.log('Gemini API response:', data);
        const resultText = data.candidates[0].content.parts
          .filter(part => part.text)
          .map(part => part.text)
          .join('\n');
      
        // Format the result for better readability
        // Parse the resultText into a structured format
        const formattedResult = resultText
        .split('\n')
        .filter(line => line.trim() !== '') // Remove empty lines
        .map(line => {
          //*   **Clock Style:**
          // Check if the line is a title (starts with "* **" and ends with ":**")
          if (line.trim().startsWith('* **') && line.trim().endsWith(':**')) {
            // Extract the title text by removing the Markdown-like syntax
            const title = line.trim().slice(4, -3); // Remove "* **" at the start and ":**" at the end
            return `<h4>${title}</h4>`;
          }
          if (line.trim().startsWith('**') && line.trim().endsWith(':**')) {
            // Extract the title text by removing the Markdown-like syntax
            const title = line.trim().slice(2, -3); // Remove "* **" at the start and ":**" at the end
            return `<h4>${title}</h4>`;
          }
          // Otherwise, wrap it in a paragraph
          return `<p>${line.trim()}</p>`;
        })
        .join('');
      
        const finalAnalysis = formattedResult + AddToResponse;
        setAnalysis(finalAnalysis);

        // Save to localStorage
        const history = JSON.parse(localStorage.getItem('imageAnalysisHistory')) || [];
        history.push({
          image: imagePreview, // Base64 image
          analysis: finalAnalysis,
          timestamp: new Date().toISOString(),
        });
        localStorage.setItem('imageAnalysisHistory', JSON.stringify(history));
      } else {
        throw new Error('Unexpected response format from Gemini API');
      }
    } catch (err) {
      setError('Failed to analyze image: ' + err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      {showIntro ? (
        <div className="intro-container">
          <h1>Welcome to Worthy!</h1>
          <p>
            This app allows you to upload images and analyze them for insights. Click the button below to get started!
          </p>
          <button className="dismiss-button" onClick={handleDismissIntro}>
            Get Started
          </button>
        </div>
      ) : (
        <>
          <div className="upload-section">
            <label className="upload-button" htmlFor="image-upload">
              {selectedImage ? 'Change Image' : 'Upload Image'}
            </label>
            <input
              id="image-upload"
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              style={{ display: 'none' }}
            />

            {/* Button for capturing an image via camera */}
            <label className="capture-button" htmlFor="camera-capture">
              Capture via Camera
            </label>
            <input
              id="camera-capture"
              type="file"
              accept="image/*"
              capture="environment" // Opens the camera in environment mode
              onChange={handleImageChange}
              style={{ display: 'none' }}
            />
          </div>

          <div className="content-container">
            <div className="image-preview-container">
              {imagePreview && (
                <img src={imagePreview} alt="Preview" className="image-preview" />
              )}
              {!imagePreview && (
                <div className="placeholder">
                  <p>Image preview will appear here</p>
                </div>
              )}
            </div>

            {(analysis || isLoading || error) && (
              <div className="analysis-container">
                {isLoading && (
                  <div className="loading">
                    <p>Analyzing image...</p>
                    <div className="spinner"></div>
                  </div>
                )}

                {error && (
                  <div className="error-message">
                    <p>{error}</p>
                  </div>
                )}

                {analysis && (
                  <div className="analysis-result">
                    <h2>Analysis Result</h2>
                    <div dangerouslySetInnerHTML={{ __html: analysis }} />
                  </div>
                )}
              </div>
            )}
          </div>

          <div className="action-buttons">
            <button className="help-button" onClick={handleShowIntro}>
              Help
            </button>
                        
            <button
              className="analyze-button"
              onClick={analyzeImage}
              disabled={!selectedImage || isLoading}
            >
              {isLoading ? 'Analyzing...' : 'Analyze Image'}
            </button>
          </div>
        
        </>
      )}
    </div>
  );
}

export default UploadPage;
